import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {HttpClientModule} from '@angular/common/http';
import {FormsModule} from '@angular/forms';

import {PrimeNGModule} from '../../core/primeNG.module';

import {DashboardRoutingModule} from './dashboard-routing.module';
import {DashboardPage} from './pages/dashboard/dashboard.page';
import {ServiceDetailsComponent} from './components/service-details/service-details.component';
import {ServiceMessagesComponent} from './components/service-messages/service-messages.component';
import {SharedModule} from '../../shared/share.module';


@NgModule({
  imports: [
    CommonModule, DashboardRoutingModule, HttpClientModule, FormsModule, PrimeNGModule, SharedModule
  ],
  exports: [RouterModule],
  declarations: [DashboardPage, ServiceDetailsComponent, ServiceMessagesComponent]
})
export class DashboardModule {
}




